import bootbox from 'bootbox';

$(document).ready(function(e){

    $('#sync-data-studio').on('click', function(){
        bootbox.alert("Sync has started. You'll be notified when its complete");

        $.ajax({
            type : 'POST',
            url : '/sync',
            success : function(res){
            },
            error : function(err){
                console.log(err);
            }
        })
    });
});